import React, { useState, useEffect } from "react";
import axiosInstance from "../ReusableComponents/Axios";
import DataTable from "../Student/Reusablecomponents/DataTable/DataTable";
import InternetChecking from "../Student/Reusablecomponents/Network";
import { RiFileExcel2Fill } from "react-icons/ri";
import Loading from "../Student/Reusablecomponents/Loading";
import notify from "../ReusableComponents/ToastifyAlerts";
import { DownloadExcel } from "../ReusableComponents/CommonFunctions";
const DownloadDetails = () => {
    const [DD, SetDD] = useState([]);
    const [Load, SetLoad] = useState(false);
    const GetDD = async () => {
        SetDD([]);
        SetLoad((prev) => !prev);
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetReportExportLog`);
            SetDD(res.data);
            SetLoad((prev) => !prev);
        }
        catch (err) { SetLoad((prev) => !prev); }
    }
    useEffect(() => {
        GetDD();
    }, [])
    const Columns = [
        { name: "Login ID", selector: "loginId", sortable: true },
        { name: "User Name", selector: "userName", sortable: true },
        { name: "Report Type", selector: "reportType", sortable: true },
        { name: "Assessment Type", selector: "assessmentTypeName", sortable: true, cell: (row) => row?.assessmentTypeName || "-" },
        { name: "Institute", selector: "instituteName", sortable: true, cell: (row) => row?.instituteName || "-" },
        { name: "Export Date and Time", selector: "downloadDateTime", sortable: true },
    ];
    const DownloadLogs = () => {
        SetLoad(true);
        if (DD?.length === 0) {
            notify("No data available to download", "info");
            return;
        }
        setTimeout(() => {
            const XL = DD?.map((item, index) => {
                return {
                    SNo: index + 1,
                    "Login ID": item.loginId,
                    "User Name": item.userName,
                    "Report Type": item?.reportType,
                    "Assessment Type": item.assessmentTypeName || "-",
                    "Institute": item.instituteName || "-",
                    "Export Date and Time": item?.downloadDateTime,
                };
            });
            DownloadExcel(XL, `Exported Reports Log`, false, `Exported Reports Log`, `Exported Reports Log`, true);
            SetLoad(false);
        }, 0);
    }
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="dflex JSBetween alignitems">
                    <div></div>
                    <div className="MainHeading"> Exported Reports Log</div>
                    <div className="ExportExcel dflex alignitems CPointer" > <RiFileExcel2Fill onClick={() => DownloadLogs()} /></div>
                </div>
                <DataTable className="NCLDataTable Card mt-2" data={DD} columns={Columns}
                    Dropdownvalues={["10", "25", "50", "100"]} ShowPagination={true} ShowPagecount={true} />
            </div>
            {Load && <Loading />}
        </>
    )
}
export default DownloadDetails;